import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faMedium, faTelegramPlane, faDiscord, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { TELEGRAM_LINK, TWITTER_LINK, MEDIUM_LINK, DISCORD_LINK, GITBOOK_LINK } from '../../../constants';
import './SocialLinks.css';

const SocialLinks = () => {
  return (
    <div className='socialLinks'>
      <a href={DISCORD_LINK} target='_blank' rel='noreferrer'>
        <FontAwesomeIcon icon={faDiscord} className='socialLinks__links__icon' />
      </a>
      <a href={TWITTER_LINK} target='_blank' rel='noreferrer'>
        <FontAwesomeIcon icon={faTwitter} className='socialLinks__links__icon' />
      </a>
      <a href={TELEGRAM_LINK} target='_blank' rel='noreferrer'>
        <FontAwesomeIcon icon={faTelegramPlane} className='socialLinks__links__icon' />
      </a>
      <a href={MEDIUM_LINK} target='_blank' rel='noreferrer'>
        <FontAwesomeIcon icon={faMedium} className='socialLinks__links__icon' />
      </a>
    </div>
  )
}

export default SocialLinks;